// 根据屏幕宽度决定是否启用“设计稿容器尺寸”。
// - 宽度 >= 750：使用设计稿 750x1334（配合整体缩放，保证一屏展示）
// - 宽度 < 750：使用 100%x100%（不缩放，依靠 rem 自适应铺满）

import Vue from 'vue'

const state = Vue.observable({
  useDesignSize: true,
})

function refresh() {
  state.useDesignSize = window.innerWidth >= 750
}

export function setupLayoutState() {
  refresh()
  window.addEventListener('resize', refresh)
}

// 用于模板里避免首次渲染闪烁
export function getUseDesignSizeNow() {
  return window.innerWidth >= 750
}

export function useDesignSizeState() {
  return state
}
